import * as React from "react";
import { Alert } from "components/bootstrap";
import LicenseHelp from "license/notifications/LicenseHelp";
const LicenseViolationNotification = () => /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: "has-bm", title: "Graylog License Violation" }, /* @__PURE__ */ React.createElement("p", null, "At least one term of your Graylog license has been violated. ", /* @__PURE__ */ React.createElement(LicenseHelp, null)));
export default LicenseViolationNotification;
